import Vue from 'vue';
import Router from 'vue-router';
import { accountSummary } from './http/requests/account';
import { rememberCheckout } from './http/requests/billing';
import FullPage from '@/layouts/full-page/FullPage.vue';
// import Landing from '@/views/Landing.vue';
import Landing from '@/views/NewLanding__4.vue';

import LerenLeren from '@/views/LerenLeren.vue';

import Creators from '@/views/Creators.vue';
import Sponsors from '@/views/Sponsors.vue';
import Promoters from '@/views/Promoters.vue';
import Operators from '@/views/Operators.vue';
import Infrastructure from '@/views/Infrastructure.vue';
import Dashboard from '@/views/new-dashboard/Dashboard.vue';
import RecordingPlay from '@/views/new-dashboard/casts/components/RecordingPlay.vue';
import AuthLayout from '@/decast/layouts/v2auth/AuthLayout.vue';
import PlayRecording from '@/views/new-dashboard/decast/components/PlayRecording.vue';
import MyProfile from './views/new-dashboard/profile/MyProfile.vue';
import JoiningLayout from '@/decast/layouts/v2joining/JoiningLayout.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: FullPage,
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        // {
        //   path: '/raw',
        //   name: 'Raw',
        //   component: () => import('./views/Raw.vue'),
        //   meta: {
        //     rule: 'isPublic',
        //   },
        // },
        {
          path: '/welcome',
          name: 'Welcome',
          component: () => import('./views/Index.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        // {
        //   path: '/about',
        //   name: 'About Us',
        //   component: () => import('./views/AboutUs.vue'),
        //   meta: {
        //     rule: 'isPublic',
        //   },
        // },
        {
          path: '/test',
          name: 'Testing',
          component: () => import('./views/Playground.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/EditNFT/:cast_Id',
          name: 'Edit NFT',
          component: () => import('./views/create-event/EditNFT.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/EditCertificate/:cast_Id',
          name: 'Edit Certificate',
          component: () => import('./views/create-event/EditCertificate.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/',
          name: 'Welcome to Decast',
          component: Landing,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/pricing',
          name: 'Pricing',
          component: () => import('@/views/pricing/PricingPage.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/creators',
          name: 'Welcome to Decast | Creators',
          component: Creators,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/promoters',
          name: 'Welcome to Decast | Promoters',
          component: Promoters,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/sponsors',
          name: 'Welcome to Decast | Sponsors',
          component: Sponsors,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/operators',
          name: 'Welcome to Decast | Operators',
          component: Operators,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/infrastructure',
          name: 'Welcome to Decast | Infrastructure',
          component: Infrastructure,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/leren-leren',
          name: 'About | Leren Leren',
          component: LerenLeren,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/oauth-callback',
          name: 'OAuthCallback',
          component: () =>
            import('./views/new-dashboard/redirects/Redirects.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/dashboard',
          redirect: '/dashboard/rooms',
          name: 'Welcome to Dashbord',
          component: Dashboard,
          meta: {
            rule: 'isLogged',
          },
          children: [
            {
              path: 'rooms/:action?',
              name: 'Welcome to Rooms',
              component: () =>
                import('./views/new-dashboard/rooms/RoomSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
            {
              path: 'casts/:action?',
              name: 'Welcome to Casts',
              component: () =>
                import('./views/new-dashboard/casts/CastSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
            {
              path: 'decast/:action?',
              name: 'Welcome to Decast',
              component: () =>
                import('./views/new-dashboard/decast/DecastSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
            {
              path: 'storage/:action?',
              name: 'Welcome to Decast',
              component: () =>
                import('./views/new-dashboard/storages/StorageSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
            {
              path: 'account/:tab?',
              name: 'Plan and Usage',
              component: () =>
                import('./views/new-dashboard/account/AccountSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
            {
              path: 'contact/:action?',
              name: 'Welcome to Decast',
              component: () =>
                import('./views/new-dashboard/contacts/ContactSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
            {
              path: 'communities',
              name: 'Welcome to Rooms',
              component: () =>
                import('./views/new-dashboard/rooms/RoomSection.vue'),
              meta: {
                rule: 'isLogged',
              },
            },
          ],
        },
        {
          path: '/play-recording/:recordingId',
          name: 'RecordingPlay',
          props: true,
          component: RecordingPlay,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/recording-play/:recordingId',
          name: 'PlayRecording',
          props: true,
          component: PlayRecording,
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/achievements',
          name: 'Awards',
          component: () => import('./views/NewAwards.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/meeting-ended',
          name: 'MeetingEnded',
          component: () => import('./views/new-dashboard/MeetingEnded.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        // {
        //   path: '/awards',
        //   name: 'Awards',
        //   component: () => import('./views/Awards_2.vue'),
        //   meta: {
        //     rule: 'isPublic',
        //   },
        // },
        {
          path: '/privacy',
          name: 'Privacy Policy',
          component: () => import('./views/PrivacyNew.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/terms',
          name: 'Terms and Conditions',
          component: () => import('./views/TermsConditions.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/workwithus',
          name: 'WorkWithUs',
          component: () => import('./views/WorkWithUs.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/room',
          name: 'Room',
          component: () => import('./views/classroom/Classroom.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        // {
        //   path: '/e/:session_key?',
        //   name: 'meetingid',
        //   component: () => import('./views/components/join/e.vue'),
        //   meta: {
        //     rule: 'isPublic',
        //   },
        // },
        {
          path: '/team',
          name: 'Teams',
          component: () => import('./views/Teams.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/goals',
          name: 'Goals',
          component: () => import('./views/Goals.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/vc',
          name: 'Video Conference',
          component: () => import('./views/VideoConference.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/awards',
          name: 'Awards',
          component: () => import('./views/Awards.vue'),
          meta: {
            rule: 'isPublic',
          },
        },

        {
          path: '/search',
          name: 'Search',
          component: () => import('./views/search/Index.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/video/:slug',
          name: 'Video View',
          component: () => import('./views/videos/NewDetailViewVideo.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/privacy-policy',
          name: 'Privacy Policy',
          component: () => import('./views/Privacy.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/terms-of-use',
          name: 'Terms of Use',
          component: () => import('./views/Terms.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/integration/ms-teams',
          name: 'MsTeams',
          component: () => import('./views/Integrations/MsTeams/MsTeams.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/integration/ocean-protocol',
          name: 'OceanProtocol',
          component: () =>
            import('./views/Integrations/OceanProtocol/OceanProtocol.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/creators',
          name: 'Creators',
          component: () => import('./views/creators/Creators.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/feedback',
          name: 'Feedback',
          component: () => import('./views/cannio/Feedback.vue'),
          meta: {
            rule: 'isLogged',
          },
        },
        {
          path: '/user_details/:session_key?',
          name: 'User Details',
          component: () => import('./views/UserDetails/UserDetails.vue'),
          meta: {
            rule: 'isLogged',
          },
        },
        {
          path: '/credentials/:castId',
          name: 'Credential Management',
          component: () => import('./views/CredentialManagementPage.vue'),
          meta: {
            rule: 'isLogged',
          },
        },
      ],
    },
    // event-registration

    // v2-login
    {
      path: '',
      component: AuthLayout,
      children: [
        {
          path: '/v2login',
          name: 'Login',
          // component: () => import('@/decast/views/v2auth/AuthLogin.vue'),
          component: () => import('@/decast/views/v2auth/DecastLogin.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/v2signup',
          name: 'SignUp',
          component: () => import('@/decast/views/v2auth/AuthSignup.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/2fa',
          name: 'TwoFactor',
          component: () =>
            import('@/decast/views/v2auth/TwoFactorAuthPage.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/configure2fa',
          name: 'Configure 2fa',
          component: () =>
            import('@/decast/views/v2auth/ConfigureTwoFactorAuth.vue'),
          meta: {
            rule: 'isLogged',
          },
        },
        {
          path: '/password-change',
          name: 'Reset password',
          component: () =>
            import('@/decast/views/v2auth/PasswordResetPage.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/auth-login-otp',
          name: 'Login to decast',
          component: () => import('@/decast/views/v2auth/MagicLinkLogin.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
      ],
    },
    // v2-joining
    {
      path: '',
      component: JoiningLayout,
      children: [
        {
          path: '/rm/:meeting_id?',
          name: 'Joining Room',
          component: () => import('./decast/views/joining-page/RoomJoin.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
        {
          path: '/cm/:meetingID?',
          name: 'Joining Room',
          component: () => import('./decast/views/joining-page/CastJoin.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
      ],
    },
    {
      path: '/did-callback',
      name: 'Did Callback',
      component: () =>
        import('@/decast/views/auth-verification/DidCallback.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/what-is-did',
      name: 'what is DID?',
      component: () => import('@/decast/views/v2auth/WhatisDid.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/event-registration/:cast_Id?',
      name: 'Event Register',
      component: () => import('./views/pages/event-register/EventRegister.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    // http://localhost:8080/e/creator/join/
    {
      path: '/e/creator/join/:cast_Id?',
      name: 'Joining',
      component: () => import('./views/Verification/CreatorJoin.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/joining/:meetingID?',
      name: 'Waiting Room',
      component: () =>
        import('./views/new-dashboard/joining-page/JoinCast.vue'),
      meta: {
        rule: 'isPublic',
      },
      props: true,
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('./views/register/Register.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/resetPassword',
      name: 'PasswordReset',
      component: () => import('./views/passwordReset/PasswordResetModal.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/login/LoginModal.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/signUp',
      name: 'SignUp',
      component: () => import('./views/register/SignUpModal.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/recording/:id',
      name: 'recording',
      component: () =>
        import('../src/views/dashboard/components/RecordingPlayer'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/cast/nft-gated/:castId?',
      name: 'Event page',
      component: () =>
        import('./views/new-dashboard/nft-gating/GatedEventPage.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/r/:meeting_id?',
      name: 'Joining Room',
      // component: () => import('./views/joiningPage.vue'),
      component: () =>
        import('./views/new-dashboard/joining-page/JoinRoom.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/c/:meetingID?',
      name: 'Joining Cast',
      component: () =>
        import('./views/new-dashboard/joining-page/JoinCast.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/n/:meetingID?',
      name: 'Joining Cast',
      component: () =>
        import('./views/new-dashboard/joining-page/JoinNftGatedCast.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/analytics/:meetingID?',
      name: 'Analytics',
      component: () =>
        import('./views/new-dashboard/analytics-page/AnalyticsPage.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/j/:shortCode?',
      name: 'Join Event',
      component: () => import('./views/new-dashboard/JoinRedirect.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/live/:eventId?',
      name: 'Stream View',
      component: () =>
        import('./views/new-dashboard/stream-page/StreamPage.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/login1',
      name: 'Login',
      component: () => import('./views/login/Login.vue'),
      meta: {
        rule: 'isPublic',
      },

      // children: [
      //   {
      //     path: '/login/',
      //     name: 'Login',
      //     component: () => import('@/views/login/components/Restricted.vue'),
      //     meta: {
      //       rule: 'isPublic',
      //       // layout: 'full',
      //       pageType: 'auth',
      //     },
      //   },
      // ],
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: () => import('./views/login/Calendar.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/color',
      name: 'ColorPicker',
      component: () => import('./views/login/ColorPicker.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/color',
      name: 'ColorPicker',
      component: () => import('./views/login/ColorPicker.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/password/reset/:token',
      name: 'Reset Password',
      component: () => import('@/views/passwordReset/Reset.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/middlepart',
      name: 'middlepart',
      component: () => import('@/views/HomePage/MiddlePart.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/privatecast',
      name: 'JoinPrivateCast',
      component: () => import('@/views/dashboard/JoinPrivateCast.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/NftBox',
      name: 'NftBox',
      component: () => import('@/views/dashboard/NftBox.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/password/email',
      name: 'Reset Email',
      component: () => import('@/views/passwordReset/Reset.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/postCast',
      name: 'Post Cast',
      component: () => import('./views/postCast.vue'),
      meta: {
        rule: 'isPublic',
      },
    },

    {
      path: '/manage',
      name: 'Dashboard',
      component: () => import('./views/dashboard/Dashboard.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/middlePart',
      name: 'RoomSection',
      component: () => import('@/views/dashboard/room-section/RoomSection.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('./views/About.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/navbar',
      name: 'Navbar',
      component: () => import('./views/Navbar.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/rightpart',
      name: 'CastSection',
      component: () => import('./views/dashboard/cast-section/CastSection.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    // {
    //   path: '/dashboard',
    //   name: 'Decast dashBoard',
    //   component: () => import('@/views/dashboard/DashboardContainer.vue'),
    //   meta: {
    //     rule: 'isLogged',
    //   },
    // },
    {
      path: '/streamcard',
      name: 'StreamCard',
      component: () => import('./views/dashboard/StreamCard.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/invite',
      name: 'InviteCard',
      component: () => import('./views/dashboard/InviteCard.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/aboutUs',
      name: 'About',
      component: () => import('./views/dashboard/AboutPage.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/contactUs',
      name: 'Contact Us',
      component: () => import('./views/dashboard/ContactUs.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    // {
    //   path: '/fall',
    //   name: 'FallBox',
    //   component: () => import('./views/dashboard/FallBox.vue'),
    //   meta: {
    //     rule: 'isPublic',
    //   },
    // },
    {
      path: '/nftw',
      name: 'NftWallet',
      component: () => import('./views/dashboard/NftWallet.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/postpone',
      name: 'postPoneCast',
      component: () => import('./views/dashboard/postPoneCast.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    // -->>>>>>>>>
    {
      path: '/eventdetails/:eventId',
      name: 'Event Details',
      component: () => import('./views/eventdetails.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/events',
      name: 'Events',
      component: () => import('./views/events/Events.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    // {
    //   path: '/live/:eventId',
    //   name: 'Stream Page',
    //   component: () => import('./views/events/StreamPage.vue'),
    //   meta: {
    //     rule: 'isPublic',
    //   },
    // },
    {
      path: '/public/nftdrop',
      name: 'Public NFT Drop',
      component: () => import('@/views/new-dashboard/nft/PublicNftMint.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/nftdrop',
      name: 'Private NFT Drop',
      component: () => import('@/views/new-dashboard/nft/PrivateNftMint.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/addfunds',
      name: 'Add Funds for Decast',
      component: () => import('@/views/new-dashboard/nft/AddFunds.vue'),
      meta: {
        rule: 'isLogged',
      },
    },
    {
      path: '/VC/:cast_id',
      name: 'Certificate',
      component: () => import('./views/create-event/GalaCertificate.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/profile',
      name: 'My Profile',
      component: MyProfile,
      meta: {
        rule: 'isLogged',
      },
    },
    {
      path: '/contact-us',
      name: 'Contact Us',
      component: () => import('./views/ContactUs.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/features',
      name: 'Features',
      component: () => import('./views/Features.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/faq',
      name: 'Faq',
      component: () => import('./views/Faq.vue'),
      meta: {
        rule: 'isPublic',
      },
    },

    {
      path: '/contact',
      name: 'Contact',
      component: () => import('./views/Contact.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/loader',
      name: 'Loading',
      component: () =>
        import('../src/components/animatedloader/animatedLoader.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/studio/:videoId?',
          name: 'Studio',
          component: () => import('./views/Home.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
      ],
    },

    {
      // =============================================================================
      // VideoWiki Class LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/videowiki-class/Index.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/integrations/Room',
          name: 'Video Wiki Class Landing',
          component: () => import('./views/videowiki-class/Landing.vue'),
          meta: {
            rule: 'isPublic',
          },
        },
      ],
    },
    {
      path: '/error/not-authorized',
      component: () => import('./views/NotAuthorized.vue'),
    },
    {
      path: '/error/404',
      component: () => import('./views/Error404.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    {
      path: '/e/:meetingID?',
      name: 'Join Cast',
      component: () =>
        import('./views/new-dashboard/joining-page/JoinCast.vue'),
      meta: {
        rule: 'isPublic',
      },
    },
    { path: '/error/500', component: () => import('./views/Error500.vue') },
    // Event comparison demo (public): the same recording, raw vs Decast brief
    {
      path: '/events-compare',
      name: 'Event Compare',
      component: () => import('@/views/event-hub/pages/ComparePage.vue'),
      meta: { rule: 'isPublic' },
    },
    // Stripe Checkout sends people back here, paid or cancelled
    {
      path: '/billing/result',
      name: 'Billing Result',
      component: () => import('@/views/pricing/BillingResult.vue'),
      meta: { rule: 'isPublic' },
    },
    // hubs that were folded into another hub or renamed; shared links keep working
    ...[
      ['presence-2026-09-13', 'ibc-2026-09', 'audience-presence'],
      ['audience-presence', 'ibc-2026-09', 'audience-presence'],
      ['28dgtl-commercial-2026-09-18', '28-digital-workshops', 's7'],
      ['pmf-workshop-2026-09-04', '28-digital-workshops', 's5'],
    ].map(([from, id, recId]) => ({
      path: `/events/${from}`,
      redirect: { name: 'Recording', params: { id, recId } },
      meta: { rule: 'isPublic' },
    })),
    // Event Hub (JSON-driven, public shareable). The shell owns the masthead and the
    // sidebar; each sidebar entry is a page of the brief, sessions sit beside them.
    {
      path: '/events/:id',
      component: () => import('@/views/event-hub/EventShell.vue'),
      meta: { rule: 'isPublic' },
      children: [
        {
          path: '',
          name: 'Event Hub',
          component: () => import('@/views/event-hub/EventBrief.vue'),
          props: { section: 'overview' },
          meta: { rule: 'isPublic' },
        },
        ...['insights', 'moments', 'files', 'authenticity'].map((section) => ({
          path: section,
          name: `Event ${section.charAt(0).toUpperCase()}${section.slice(1)}`,
          component: () => import('@/views/event-hub/EventBrief.vue'),
          props: { section },
          meta: { rule: 'isPublic' },
        })),
        {
          path: 'sessions/:recId',
          name: 'Recording',
          component: () => import('@/views/event-hub/RecordingView.vue'),
          meta: { rule: 'isPublic' },
        },
        {
          path: 'sessions',
          redirect: (to) => ({
            name: 'Event Hub',
            params: { id: to.params.id },
          }),
        },
        // links shared before the restructure pointed straight at /events/:id/:recId
        {
          path: ':recId',
          redirect: (to) => ({ name: 'Recording', params: to.params }),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error/404',
    },
  ],
});

// Prime the account summary once a signed-in person lands anywhere in the product, so the
// header chip and the usage banner have an answer before they are looked at.
router.beforeEach((to, from, next) => {
  const signedIn = !!localStorage.getItem('accessToken');

  // Someone arriving with a plan already chosen, usually from the marketing site. Remember
  // it whatever their state: a token can be present but dead, in which case the session
  // fails a moment later and they are sent to sign in. The choice has to survive that, or
  // they arrive at a sign-in page with no idea why and nothing waiting for them.
  if (to.query.plan) {
    const tier = String(to.query.plan).split('-')[0];
    const interval = to.query.interval
      ? String(to.query.interval)
      : /-year$/.test(String(to.query.plan))
      ? 'year'
      : 'month';
    rememberCheckout(`${tier}-${interval}`);
    if (!signedIn) {
      next('/v2signup');
      return;
    }
  }

  if (to.meta && to.meta.rule === 'isLogged' && signedIn) {
    accountSummary().catch(() => {});
  }
  next();
});

router.afterEach((to, from) => {
  // Remove initial loading
  document.title = to.name;
});

export default router;
